import { gql } from '@apollo/client'

const inProfileCollectionsCategoriesFragment = gql`
  fragment inProfileCollectionsCategoriesFragment on PublicProfile {
    inProfileCollections {
      id
      slug
      publicCmsItem {
        id
        content
      }
    }
  }
`

export default inProfileCollectionsCategoriesFragment
